import axios from 'axios'

// Use relative URL for API (respects same domain) or env override
// In dev: http://localhost:5173 → http://localhost:8000/api (via vite proxy)
// In prod: https://hina-pulse.vercel.app → /api (same domain)
const API_BASE_URL = import.meta.env.VITE_API_URL || '/api'

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
})

api.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Token ${token}`
    }

    // Add email/hashid authentication headers
    const userEmail = localStorage.getItem('userEmail')
    const userHashId = localStorage.getItem('userHashId')
    if (userEmail && userHashId) {
      config.headers['X-User-Email'] = userEmail
      config.headers['X-User-HashID'] = userHashId
    }

    return config
  },
  error => Promise.reject(error)
)

api.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token')
      // Only redirect if not already on login page
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/login'
      }
    }
    return Promise.reject(error)
  }
)

export default api
